﻿import { ELocalStorageKey, EUserType } from '/@/types/enums'
import { CURRENT_CONFIG } from '/@/api/http/config'
import { cachePageInfo } from '/@/utils/page-info'

export function getWebsocketUrl (explicitDockSn?: string) {
  const token: string = localStorage.getItem(ELocalStorageKey.Token) || '' as string
  const dock_sn: string = explicitDockSn || localStorage.getItem('dock_sn') || '' as string
  const url = CURRENT_CONFIG.websocketURL + '?x-auth-token=' + encodeURI(token) + '&device_sn=' + dock_sn
  return url
}
export function getWebsocketPushUrl () {
  const url = CURRENT_CONFIG.websocketPushURL
  return url
}
// deepseek websocket
export function getWebsocketDeepseekURL () {
  // const region_code = localStorage.getItem('region_code') || 'deepseek' as string
  const region_code = 'deepseek'
  const url = CURRENT_CONFIG.websocketDeepseekURL + region_code
  return url
}
interface LoginResult {
  data: {
    access_token: string,
    username: string,
    name: string,
    user_id: string,
    page_info: object,
    region_code: string,
    role_id: string,
    role_key: string,
    perms_vo_list: any[],
    home_config?: any,
  }
}
// 获取权限
function menuPerms (menu:any, perms:any) {
  menu.forEach((el:any) => {
    if (el.perms) {
      perms.push(el.perms)
    }
    if (el.children != null && el.children && el.children.length) {
      el.children = menuPerms(el.children, perms)
    } else {
      delete el.children
    }
  })
  return perms
}
export function loginSuccess (result :LoginResult) {
  localStorage.setItem(ELocalStorageKey.Token, result.data.access_token)
  localStorage.setItem(ELocalStorageKey.Username, result.data.username)
  localStorage.setItem('name', result.data.name)
  localStorage.setItem(ELocalStorageKey.UserId, result.data.user_id)
  cachePageInfo(result.data.page_info)
  localStorage.setItem(ELocalStorageKey.RegionCode, result.data.region_code)
  localStorage.setItem(ELocalStorageKey.RoleId, result.data.role_id)
  localStorage.setItem(ELocalStorageKey.RoleKey, result.data.role_key)
  localStorage.setItem(ELocalStorageKey.MenuList, JSON.stringify(result.data.perms_vo_list))
  if (result.data.home_config && Number(result.data.home_config.enabled) === 1) {
    localStorage.setItem(ELocalStorageKey.HomeConfig, JSON.stringify(result.data.home_config))
  } else {
    localStorage.removeItem(ELocalStorageKey.HomeConfig)
  }
  localStorage.setItem('perms', JSON.stringify(menuPerms(result.data.perms_vo_list, [])))
  localStorage.setItem(ELocalStorageKey.Flag, EUserType.Web.toString())
}
